<div class="row no-gutters position-relative">
  <div class="position-absolute icon-line"></div>
  <div class="col-auto icon-container">
    <i class="fa {{iconClass}}"></i>
  </div>
  <div class="col">
    <ng-content></ng-content>
  </div>
</div>
